import React, { useEffect, useState, useRef } from "react";
import { db, auth } from "../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import { useNavigate, useLocation } from "react-router-dom";

function Engage() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = auth.currentUser;
  const isLoggedIn = !!user;

  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [mySpace, setMySpace] = useState(null);
  const [dateTime, setDateTime] = useState("");
  const [canWrite, setCanWrite] = useState(true);
  const [text, setText] = useState("");


  /* ================= CLOCK ================= */
  useEffect(() => {
    const updateClock = () => {
      const now = new Date();
      const datePart = now.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      });
      const dayPart = now.toLocaleDateString("en-US", {
        weekday: "long",
      });
      const timePart = now.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
      setDateTime(`${dayPart} ✦ ${datePart} ✦ ${timePart}`);
    };
    updateClock();
    const interval = setInterval(updateClock, 1000);
    return () => clearInterval(interval);
  }, []);

  /* ================= FETCH ================= */
  useEffect(() => {
    if (!user) return;

    const fetchMySpace = async () => {
      const q = query(
        collection(db, "spaces"),
        where("userId", "==", user.uid)
      );
      const snap = await getDocs(q);
      if (!snap.empty) {
        setMySpace(snap.docs[0].data());
      }
    };

    fetchMySpace();
  }, [user]);

  useEffect(() => {
    const fetchUsers = async () => {
      const snap = await getDocs(collection(db, "users"));
      const list = snap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setUsers(list);
    };
    fetchUsers();
  }, []);

  useEffect(() => {
  const lastPost = localStorage.getItem("lastPostTime");

  if (lastPost) {
    const diff = Date.now() - Number(lastPost);
    const remaining = 30 * 60 * 1000 - diff;

    if (remaining > 0) {
      setCanWrite(false);
      setTimeout(() => setCanWrite(true), remaining);
    }
  }
}, []);

  const filteredUsers =
    search.trim() === ""
      ? []
      : users.filter(
          (u) =>
            u.name &&
            u.name.toLowerCase().includes(search.toLowerCase())
        );

  const headerLineText = isLoggedIn
  ? "✦ Start by building your space ✦"
  : "✦ Be a member and create your story with us! ✦";

  return (
        <div
          style={{
            minHeight: '100vh',
            width: '100%',
            backgroundColor: 'linear-gradient(135deg, #e7e7e7, #dcdcdc), radial-gradient(circle at 30% 20%, rgba(255,255,255,0.4), transparent 40%), radial-gradient(circle at 70% 80%, rgba(0,0,0,0.08), transparent 45%)',
            fontFamily: '"Inter", sans-serif',
            color: '#000',
            overflowX: 'hidden',
            overflowY: 'auto',
            paddingTop: '92px',
            boxSizing: 'border-box',
          }}
        >
          {/* HEADER */}
          <div
            style={{
              width: '100%',
              minHeight: '60px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingRight: '20px',
              paddingLeft: '20px',
              position: 'fixed',
              top: 0,
              backgroundColor: '#F2E7E0',
              color: '#000',
              zIndex: 100,
              boxSizing: 'border-box',
            }}
          >
            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', alignItems: 'center' }}>
              <span onClick={() => navigate(isLoggedIn ? "/home" : "/")} className={`nav-item ${location.pathname === "/" ? "active" : "" }`} > Home </span>
              <span onClick={() => navigate("/engage")} className={`nav-item ${location.pathname === "/engage" ? "active" : "" }`} > Engage </span>
              <span onClick={() => navigate('/yard')} className={`nav-item ${location.pathname === '/yard' ? 'active' : ''}`} > Yard </span>
            </div>
            <div className="datetime" style={{ fontWeight: 'normal', fontSize: '0.9rem', whiteSpace: 'nowrap', flexShrink: 0 }}>
              {dateTime}
            </div>
          </div>

          {/* GRAY LINE */}
          <div style={{
            width: '100%',
            backgroundColor: '#696969',
            height: '23px',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'fixed',
            top: '58px',
            zIndex: 90,
          }}>
            <span className="slide-right-text">{headerLineText}</span>
          </div>

<div style={styles.center}>

  {isLoggedIn && (
    <button
      style={styles.button}
      onClick={() =>
        mySpace?.spaceLink
          ? navigate(`/${mySpace.spaceLink}`)
          : navigate("/build")
      }
    >
      Open SPACE
    </button>
  )}

<div style={styles.statusText}>
  {isLoggedIn ? (
    <>
      More features are on the way.
      <br />
      Start by exploring SPACE.
    </>
  ) : (
    <>
      Unlock space to discover more — return to HOME
    </>
  )}
</div>

</div>
        
      {/* STYLES */}
      <style>{`
            .slide-right-text {
              color: #ffff;
              display: inline-block;
              font-family: 'Inter', sans-serif;
              font-size: 14px;
              font-weight: 100;
              letter-spacing: 1.1px;
              white-space: nowrap;
              position: relative;
              animation: slideRight 8s ease-in-out infinite;
            }
            @keyframes slideRight {
              0% { transform: translateX(120%) scaleY(.9); opacity: 0; }
              18.75% { transform: translateX(0%) scaleY(0.9); opacity: 1; }
              81.25% { transform: translateX(0%) scaleY(0.9); opacity: 1; }
              100% { transform: translateX(-120%) scaleY(0.9); opacity: 0; }
            }
              .nav-item {
              cursor: pointer;
              font-family: 'Inter', sans-serif;
              font-size: 14px;
              font-weight: 200;
              letter-spacing: .3px;
              transform: scaleY(.85) translateY(1px);
              text-transform: uppercase;
              display: inline-block;
              color: #464646;
            }

            /* Hover bounce */
            .nav-item:hover {
              color: #000;
            }

            /* Active tab */
            .nav-item.active {
              font-weight: 700;
              color: #000;
            }

            /* Keep hover working on active */
            .nav-item.active:hover {
            }

            @media (max-width: 600px) {
              .datetime {
              display: none !important; 
              }
            }

            .panel {
              max-width: 100%;
            }
              
            .datetime {
              display: inline-block;
              font-family: 'Inter', sans-serif;
              font-size: 14px;
              letter-spacing: 1px;
              transform: scaleY(.9);
            }
      `}</style>
    </div>
  );
}

export default Engage;

/* ================= STYLES ================= */
const styles = {
  grayLine: {
    width: '100%',
    backgroundColor: '#696969',
    height: '23px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#ffff',
    position: 'fixed',
    top: '58px',
    zIndex: 90,
  },

center: {
  position: "relative",
  width: "100%",
  maxWidth: "600px",
  margin: "0 auto",
  padding: "0 10px",

  height: "calc(100vh - 150px)", // 👈 IMPORTANT (accounts header + ticker)

  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",

  textAlign: "center",
  boxSizing: "border-box",
  gap: "12px",
},

button: {
  padding: "12px",
  borderRadius: "20px",
  border: "none",
  background: "#696969",
  color: "#fff",
  cursor: "pointer",
},

  user: {
    padding: "8px",
    cursor: "pointer",
  },

  spaceTag: {
    fontSize: "12px",
    opacity: 0.6,
  },

statusText: {
  fontSize: "16px",
  fontWeight: "400",
  color: "#555",
  textAlign: "center",
  lineHeight: "1.5",
},
};